"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardStatus = exports.CardFee = exports.CardType = void 0;
var CardType;
(function (CardType) {
    CardType["PHYSICAL"] = "PHYSICAL";
    CardType["VIRTUAL"] = "VIRTUAL";
})(CardType = exports.CardType || (exports.CardType = {}));
var CardFee;
(function (CardFee) {
    CardFee["NONE"] = "NONE";
    CardFee["STANDARD"] = "STANDARD";
    CardFee["STARTER"] = "STARTER";
    CardFee["ESSENTIAL"] = "ESSENTIAL";
    CardFee["ADVANCED"] = "ADVANCED";
})(CardFee = exports.CardFee || (exports.CardFee = {}));
var CardStatus;
(function (CardStatus) {
    CardStatus["DEACTIVATED"] = "DEACTIVATED";
    CardStatus["DESTROYED"] = "DESTROYED";
    CardStatus["EXPIRED"] = "EXPIRED";
    CardStatus["LIVE"] = "LIVE";
    CardStatus["LOST"] = "LOST";
    CardStatus["RESTRICTED"] = "RESTRICTED";
    CardStatus["STOLEN"] = "STOLEN";
})(CardStatus = exports.CardStatus || (exports.CardStatus = {}));
//# sourceMappingURL=card.js.map